export default {
  "content": "<g clip-path=\"url(#icon_emptystate_not-eligible_svg__a)\"><path fill-rule=\"evenodd\" d=\"M13.333 12.143h-.173L9.147 1.65C8.773.516 7.133.516 6.76 1.65L2.827 12.143h-.16c-.734 0-1.334.587-1.334 1.333 0 .747.6 1.334 1.334 1.334h10.666c.734 0 1.334-.6 1.334-1.334 0-.733-.6-1.333-1.334-1.333zM8 4.476c.733 0 1.333.6 1.333 1.334 0 .733-.6 1.333-1.333 1.333s-1.333-.6-1.333-1.333c0-.734.6-1.334 1.333-1.334zm-3.093 6.627c0-.573.466-1.04 1.04-1.04h4.106a1.041 1.041 0 010 2.08H5.947c-.574 0-1.04-.467-1.04-1.04z\" clip-rule=\"evenodd\"/></g><defs><clipPath id=\"icon_emptystate_not-eligible_svg__a\"><path d=\"M0 0h16v16H0z\"/></clipPath></defs>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "16",
    "height": "16",
    "fill": "currentColor",
    "viewBox": "0 0 16 16"
  }
};